import InferenceEvents from './InferenceEvents.container';

export default InferenceEvents;
